module.exports = __webpack_public_path__ + "media/components/src/assets/images/i_sort-27e908444fbb877bc8445e1a2202c13d.svg";